// Libraries
var React = require('react');
var Slider = null;

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./LatestScores.scss');

class LatestScores extends React.Component {
	constructor(props) {
		super(props);

		this.settings = {
			dots: false,
			infinite: true,
			arrows: false,
			speed: 500,
			vertical: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			touchMove: false,
			draggable: false
		};

		this.state = {
			homeScorers: [],
			awayScorers: []
		}
	}

	componentDidMount() {
		// this is here to prevent window being undefined when rendered server side
		Slider = require('react-slick').default;
		this.groupScorers();

		// Due to a bug in react-slick, the carousel is rendering before it's children
		// which is causing the carousel's 'slick-list' element to have a height of 0px.
			// This work around forces the library to redraw the carousel.
			// TODO: replace the library or find a better solution
			// ISSUE: https://github.com/akiran/react-slick/issues/809#issuecomment-325807788
			setTimeout(() => {
				let elem = document.querySelector('.slick-list');
				if(elem && elem.style.height === "0px") {
					window.dispatchEvent(new Event('resize'));
				}
			}, 1000);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.homeScorers !== this.props.homeScorers || nextProps.awayScorers !== this.props.awayScorers) {
			this.groupScorers();
		}
	}

	groupScorers = () => {
		let size = 3;

		let homeScorersArrays = [];
		let homeScorers = this.props.homeScorers.slice();

		while (homeScorers.length > 0)
			homeScorersArrays.push(homeScorers.splice(0, size));

		let awayScorersArrays = [];
		let awayScorers = this.props.awayScorers.slice();

		while (awayScorers.length > 0)
			awayScorersArrays.push(awayScorers.splice(0, size));
		while (awayScorers.length > 0)
			awayScorersArrays.push(awayScorers.splice(0, size));

		this.setState({ homeScorers: homeScorersArrays, awayScorers: awayScorersArrays });
	}

	render() {
		return (
			<div className="LatestScores">
				<div className="LatestScores__goals--left">
					{Slider && this.state.homeScorers.length > 0 &&
							<Slider {...this.settings} autoplay={this.state.homeScorers.length > 1}>
								{this.state.homeScorers.map((homeScorers, outerIndex) => {
									return (
										<div className="LatestScores__group" key={outerIndex}>
											<div className="LatestScores__innerwrapper">
												{homeScorers.map((scorer, index) => {
													return (<p key={index}>{scorer.Surname} ({scorer.GoalTimes + "'"})</p>);
												})}
											</div>
										</div>
									)
								})}
							</Slider>
					}
				</div>
				<div className="LatestScores__score">
					<div className="wrapper">
						<div className="LatestScores__score--left">
							{this.props.homeCrestUrl &&
									<img src={PlaceholderImg} data-src={this.props.homeCrestUrl} alt="Home team crest" />
							}
							<div className="LatestScores__name"><abbr title={this.props.homeName}>{this.props.homeShortName}</abbr></div>
						</div>
						<div className="LatestScores__score--middle">
							{this.props.score && <p className="score">{this.props.score}</p>}
							{this.props.displayMinute && <p>{this.props.displayMinute}</p>}
							{this.props.aggregateScore && <p>(Agg {this.props.aggregateScore})</p>}
						</div>
						<div className="LatestScores__score--right">
							{this.props.awayCrestUrl &&
									<img src={PlaceholderImg} data-src={this.props.awayCrestUrl} alt="Away team crest" />
							}
							<div className="LatestScores__name"><abbr title={this.props.awayName}>{this.props.awayShortName}</abbr></div>
						</div>
					</div>
				</div>
				<div className="LatestScores__goals--right">
					{Slider && this.state.awayScorers.length > 0 &&
							<Slider {...this.settings} autoplay={this.state.awayScorers.length > 1}>
								{this.state.awayScorers.map((awayScorers, outerIndex) => {
									return (
										<div className="LatestScores__group" key={outerIndex}>
											<div className="LatestScores__innerwrapper">
												{awayScorers.map((scorer, index) => {
													return (<p key={index}>{scorer.Surname} ({scorer.GoalTimes + "'"})</p>);
												})}
											</div>
										</div>
									)
								})}
							</Slider>
					}
				</div>
			</div>
		)
	}
}

module.exports = LatestScores;



// WEBPACK FOOTER //
// ./src/components/MDC/LiveGameSummary/LatestScores.js